export default "__VITE_ASSET__BkX$6ZHq__"